import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useGetProjectByProjectnameQuery } from './slices/usersApiSlice';
import DeveloperPortfolio from './templates/DeveloperPortfolio';
import DeveloperPortfolioNew from './templates/DeveloperPortfolioNew';
import TylerDurden from './templates/TylerDurden';
import axios from 'axios';
// import RealEstateLanding from '../templates/RealEstateLanding';
// import DoctorLanding from '../templates/DoctorLanding';
// import ClinicLanding from '../templates/ClinicLanding';

const UserLandingPage = () => {
    const params = useParams();
    console.log('Params:', params);

    const { projectName } = params;
    const { 
        data: userData,
        isLoading,
        isError,
        error
    } = useGetProjectByProjectnameQuery(projectName);

    // Track portfolio visit
    useEffect(() => {
        if (!isLoading && userData?.project?.projectName) {
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
            const sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            
            // Store session ID in sessionStorage
            if (!sessionStorage.getItem('sessionId')) {
                sessionStorage.setItem('sessionId', sessionId);
            }

            // Track visit
            axios.post(`${apiUrl}/v1/analytics/track/visit/${projectName}`, {}, {
                headers: {
                    'X-Session-Id': sessionStorage.getItem('sessionId') || sessionId,
                }
            }).catch((err) => {
                console.error('Failed to track visit:', err);
            });
        }
    }, [isLoading, userData, projectName]);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        console.error('Error fetching user:', error);
        return <Navigate to="/404" />;
    }

    // Template map object
    const templateMap = {
        'default': DeveloperPortfolio,
        'developer': DeveloperPortfolioNew,
        'tyler': TylerDurden,
        // 'clinic': ClinicLanding,
    };

    // Get the component based on the selectedTemplate
    const TemplateComponent = templateMap[userData.project.template];

    // If the selected template is not found, render 404
    if (!TemplateComponent) {
        return <Navigate to="/404" />;
    }

    // Render the template component
    return <TemplateComponent userData={userData} />;
};

export default UserLandingPage;
